import { createFileRoute } from '@tanstack/react-router';

import StorePagePage from '@/components/store/pages/specific/Page';

export const Route = createFileRoute('/store/pages/$id')({
	component: StorePagePage,
});
